import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import { HelperText } from '@qbe/ads-blocks-forms';
import { Box, Icon, Typography, useTheme, useMediaQuery } from '@qbe/ads-core';
import { useContent, useContentContext } from '@qbe/dfc-content';

type Props = {
  isFNH: boolean;
};

export const CallUs = ({ isFNH }: Props) => {
  const { getTextContent } = useContent({ context: useContentContext() });

  // Localized content constants
  const baseContentKey = `contactUs.${isFNH ? 'hardship' : 'normal'}`;
  const subtitleText = getTextContent(`${baseContentKey}.subtitle`);
  const numberText = getTextContent(`${baseContentKey}.number`);

  const theme = useTheme();
  const showFixedLayout = useMediaQuery(theme.breakpoints.up(1150));

  if (showFixedLayout) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: '120px',
          right: '0',
        }}
      >
        <HelperText
          variant="light"
          overrideBackground="transparent"
          disableShadow
          header={<Typography variant="subtitle2">{subtitleText}</Typography>}
          content={
            <Typography variant="h6">
              <Icon muiIcon={PhoneIcon} color="black" size={20} />
              {numberText}
            </Typography>
          }
        />
      </Box>
    );
  } else {
    return (
      <Box width="100%" textAlign="right">
        <Typography variant="subtitle2" display="inline">
          {subtitleText}
        </Typography>
        <Typography variant="h6" display="inline" noWrap>
          {' '}
          <Icon muiIcon={PhoneIcon} color="black" size={20} />
          {numberText}
        </Typography>
      </Box>
    );
  }
};

export default CallUs;
